import Skeleton from 'src/components/Skeleton';
import styles from './SkeletonContainer.module.scss';

interface IModalProps {
  hiddenTitle?: boolean;
}

const SkeletonContainer = ({ hiddenTitle }: IModalProps) => (
  <div data-testid="skeleton-container">
    {!hiddenTitle && (
      <div className={styles['header']} data-testid="skeleton-header">
        <Skeleton variant="text" height={50} width={145} data-testid="skeleton-header-title" />
        <Skeleton variant="circular" height={35} width={35} data-testid="skeleton-header-avatar" />
      </div>
    )}
    <div className={styles['top-tiles']}>
      {[...Array(5)].map((_n, i) => (
        <div key={`title-${i}`}>
          <Skeleton variant="text" height={32} width={145} data-testid="skeleton-top-tile" />
        </div>
      ))}
    </div>
    <div className={styles['tiles']}>
      {[...Array(10)].map((_n, i) => (
        <Skeleton key={`row-${i}`} variant="rectangular" data-testid="skeleton-tile" />
      ))}
    </div>
  </div>
);

export default SkeletonContainer;
